/**
 * Protected route wrapper - redirects to login if not authenticated
 *
 * Supports:
 * - requireAdmin: Enforce admin-only access (redirects non-admins to /inicio)
 */

import { Navigate, useLocation } from 'react-router-dom';
import { useAppStore } from '../../stores/appStore';
import { getProtectedRouteRedirect } from './protected-route-logic';

interface ProtectedRouteProps {
  children: React.ReactNode;
  /** If true, only admin users can access this route */
  requireAdmin?: boolean;
}

export default function ProtectedRoute({ children, requireAdmin }: ProtectedRouteProps) {
  const user = useAppStore((state) => state.user);
  const isAuthenticated = useAppStore((state) => state.isAuthenticated);
  const location = useLocation();

  const redirectTo = getProtectedRouteRedirect({
    isAuthenticated,
    user,
    requireAdmin: !!requireAdmin,
  });

  if (redirectTo) {
    const shouldPreserveFrom = redirectTo === '/entrar' || redirectTo === '/seguranca';
    return (
      <Navigate
        to={redirectTo}
        state={shouldPreserveFrom ? { from: location } : undefined}
        replace
      />
    );
  }

  return <>{children}</>;
}
